import styled from 'styled-components'
import { colors } from '../../lib/colors'
interface TEXT_STYLED_PROPS {
  margin?: string
}
export const Title = styled.div`
  font-size: 18px;
  color: ${colors.secondary};
  margin-bottom: 6px;
`

export const TextWrapper = styled.div<TEXT_STYLED_PROPS>`
  text-align: center;
  font-size: 12px;
  color: ${colors.quaternary};
  text-transform: uppercase;
  margin: ${({ margin }) => margin || '0 0 30px 0'};
  span {
    margin-left: 5px;
    color: ${colors.secondary};
  }
`
